/** @jsxImportSource @emotion/react */
import { t as coreT } from '@lingui/core/macro';
import { useLingui } from '@lingui/react/macro';
import { Form, Formik, FormikHelpers } from 'formik';
import React, { useMemo } from 'react';
import { UDFormDropzone } from 'ud-form/components/image-dropzone';
import UDFormInput from 'ud-form/components/input';
import { validPhoneRegex } from 'shared/validators/phone.validator';
import UDInputPhone from 'ud-form/components/input/ud-input-phone';
import { UDButton } from 'ud-ui/components';
import Modal from 'ud-ui/components/modal';
import * as yup from 'yup';

export const userValidator = (checkPhone: boolean) =>
  yup.object().shape({
    name: yup.string().required(() => coreT`Обязательное поле`),
    surname: yup.string().required(() => coreT`Обязательное поле`),
    phone: checkPhone
      ? yup
          .string()
          .required(() => coreT`Обязательное поле`)
          .matches(validPhoneRegex, () => coreT`Введите корректный номер телефона`)
      : yup.string().nullable(),
  });

export type RolesManagerFormValues = {
  name: string;
  surname: string;
  middleName?: string;
  email?: string;
  birthDay?: string;
  phone: string;
  photo?: any;
};

interface IRolesManagerFormProps {
  initValue?: RolesManagerFormValues;
  onSubmit: (values: RolesManagerFormValues, formikHelpers: FormikHelpers<RolesManagerFormValues>) => void;
}

function RolesManagerForm(props: IRolesManagerFormProps) {
  const { t } = useLingui();
  const {
    initValue = {
      name: '',
      surname: '',
      middleName: '',
      email: '',
      phone: '',
      photo: null,
    },
    onSubmit,
  } = props;

  const isEdit = useMemo(() => {
    return Boolean(props.initValue);
  }, [props.initValue]);

  return (
    <Formik initialValues={initValue} onSubmit={onSubmit} validationSchema={() => userValidator(!isEdit)}>
      {(formProps) => (
        <Form className="w-[454px]">
          <Modal.Body className="flex flex-col gap-4 overflow-hidden">
            <UDFormInput name="surname" placeholder={t`Фамилия`} errorVisible />
            <UDFormInput name="name" placeholder={t`Имя`} errorVisible />
            <UDFormInput name="middleName" placeholder={t`Отчество`} />
            {isEdit ? (
              <UDFormInput name="phone" placeholder={t`Телефон`} disabled />
            ) : (
              <UDInputPhone name="phone" placeholder={t`Телефон`} errorVisible />
            )}
            <UDFormInput name="email" placeholder={t`Почта`} disabled={isEdit} />
            <UDFormDropzone name="photo" preview="inside" crop removable />
          </Modal.Body>
          <Modal.Footer>
            <UDButton variant="primary" type="submit" loading={formProps.isSubmitting} stretch disabled={!formProps.dirty}>
              {isEdit ? t`Сохранить` : t`Создать`}
            </UDButton>
          </Modal.Footer>
        </Form>
      )}
    </Formik>
  );
}

export default RolesManagerForm;
